import { useLocation } from "react-router-dom";
import MainContent from "../../../components/mainContent/MainContent"
import { GenerarMinutaDetalleContent } from "./GenerarMinutaDetalleContent"

export const GenerarMinutaDetalle = () => {
    const location = useLocation();
    const { allowedWrite, dataRegistro, idDelegacion, delegacion, periodoActivo } = location.state; 
    
    return (
        <MainContent
            component={<GenerarMinutaDetalleContent                 
                allowedWrite={allowedWrite}
                dataRegistro={dataRegistro} 
                idDelegacion={idDelegacion}
                delegacion={delegacion}
                periodoActivo={periodoActivo}
            />}
            titulo={"Visualización de Minuta"}
            noBackground
            tableMaxWidth
        />
    )    
}